import {Pipe, PipeTransform} from "@angular/core";
import {ADMINISTRATOR_ROLE, DIGI_ROLE, HELPER_ROLE, ORGANIZER_ROLE, USER_ROLE} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform{
  constructor(private translocoService: TranslocoService) {
  }

  transform(role: string|undefined) {
    return this._getRoleTitle(role);
  }

  _getRoleTitle(role?: string): string {
    switch (role) {
      case ORGANIZER_ROLE:
        return this.translocoService.translate("app.common.role.organiser");
      case ADMINISTRATOR_ROLE:
        return this.translocoService.translate("app.common.role.admin");
      case USER_ROLE:
        return this.translocoService.translate("app.common.role.user");
      case HELPER_ROLE:
        return this.translocoService.translate("app.common.role.helper");
      case DIGI_ROLE:
        return this.translocoService.translate("app.common.role.digi");
      default:
        return "-";
    }
  }
}
